<div class="login activate-account">
  <h1>Activate your account</h1>

  <div class="label info" *ngIf="checkingToken">
    Checking your activation link...
  </div>

  <div class="label info red no-margin-top" *ngIf="!checkingToken && !tokenValid">
    This activation link has expired or has already been used. Please ask your organisation's administrator
    to resend the activation email, then use the new link.
  </div>

  <form *ngIf="!checkingToken && tokenValid" #accountActivationForm="ngForm"
        (submit)="accountActivationForm.form.valid && onAccountActivate()">

    <div class="form-group">
      <label for="password">password</label>
      <input aria-label=""
             [type]="showPassword ? 'text' : 'password'"
             id="password"
             [(ngModel)]="activateAccountVM.password"
             name="password"
             class="auth-input"
             triggers="manual"
             placement="right"
             required>
      <div class="password-eye" (click)="showPassword = !showPassword">
        <svg xmlns="http://www.w3.org/2000/svg" width="24.43" height="19" viewBox="0 0 25.929 20.5">
          <g id="Group_179" data-name="Group 179" transform="translate(-2.25 -4.25)">
            <path id="Path_280" data-name="Path 280"
                  d="M15.952,10.194a4.074,4.074,0,1,1-5.761,0,4.077,4.077,0,0,1,5.761,0" transform="translate(2.142 1.429)"
                  fill="none" stroke="#bababa" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
            <path id="Path_281" data-name="Path 281"
                  d="M3,14.5a5.9,5.9,0,0,1,.605-2.595h0A12.829,12.829,0,0,1,15.214,5a12.829,12.829,0,0,1,11.609,6.905h0a5.865,5.865,0,0,1,0,5.19h0A12.829,12.829,0,0,1,15.214,24,12.829,12.829,0,0,1,3.605,17.095h0A5.9,5.9,0,0,1,3,14.5Z"
                  transform="translate(0)" fill="none" stroke="#bababa" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.5" fill-rule="evenodd" />
          </g>
        </svg>
      </div>
      <label for="passwordConfirmation">confirm password</label>
      <input aria-label=""
             [type]="showPassword ? 'text' : 'password'"
             id="passwordConfirmation"
             [(ngModel)]="activateAccountVM.passwordConfirmation"
             name="passwordConfirmation"
             class="auth-input"
             triggers="manual"
             placement="right"
             required>

      <!-- <div class="password-confirmation-group">
          <label for="passwordConfirmation">confirm password</label> {{showConfirmPassword}}
          <input aria-label="password confirmation"
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="passwordConfirmation"
              [(ngModel)]="activateAccountVM.passwordConfirmation"
              name="passwordConfirmation"
              class="auth-input"
              triggers="manual"
              placement="right"
              required> -->
      <!-- <div class="password-eye-confirm" (click)="showConfirmPassword = !showConfirmPassword">
          <svg xmlns="http://www.w3.org/2000/svg" width="24.43" height="19" viewBox="0 0 25.929 20.5">
              <g id="Group_180" data-name="Group 180" transform="translate(-2.25 -4.25)">
              <path id="Path_280" data-name="Path 280"
                  d="M15.952,10.194a4.074,4.074,0,1,1-5.761,0,4.077,4.077,0,0,1,5.761,0" transform="translate(2.142 1.429)"
                  fill="none" stroke="#bababa" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
              <path id="Path_281" data-name="Path 281"
                  d="M3,14.5a5.9,5.9,0,0,1,.605-2.595h0A12.829,12.829,0,0,1,15.214,5a12.829,12.829,0,0,1,11.609,6.905h0a5.865,5.865,0,0,1,0,5.19h0A12.829,12.829,0,0,1,15.214,24,12.829,12.829,0,0,1,3.605,17.095h0A5.9,5.9,0,0,1,3,14.5Z"
                  transform="translate(0)" fill="none" stroke="#bababa" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.5" fill-rule="evenodd" />
              </g>
          </svg>
      </div> -->
      <!-- </div> -->

      <div class="label info red no-margin-top" *ngIf="!activationSuccessful && accountActivationMessage !== ''">
        {{accountActivationMessage}}
      </div>
      <div class="label info green no-margin-top" *ngIf="activationSuccessful && accountActivationMessage !== ''">
        {{accountActivationMessage}}
      </div>
    </div>

    <button type="submit" class="auth-submit">Activate Account</button>
  
  </form>
</div>
